import { IndicatorWrapper } from 'components';
import { EnvironmentWithIndicators } from 'generated';
import { RouteConfigItem } from 'models';

type BaseType<T> = T & { order: number };

function sortByOrder<T>(a: BaseType<T>, b: BaseType<T>): number {
  return a.order - b.order;
}

export function formatIndicatorName(
  contexts: EnvironmentWithIndicators[],
): EnvironmentWithIndicators[] {
  let currentIndex = 1;
  const formattedContexts = contexts.map(context => ({
    ...context,
    indicators: context.indicators.map(indicator => {
      currentIndex += 1;
      return {
        ...indicator,
        name: `${currentIndex - 1}. ${indicator.name}`,
      };
    }),
  }));

  return formattedContexts;
}

export function generateRoutes(
  contexts: EnvironmentWithIndicators[],
): RouteConfigItem[] {
  if (!contexts || !contexts?.length) {
    return [];
  }

  const mappedContexts = [...contexts];

  const routes: RouteConfigItem[] = mappedContexts
    .sort(sortByOrder)
    .reduce((accumulator: RouteConfigItem[], context) => {
      const contextIndicators = [...context.indicators];
      const indicators: RouteConfigItem[] = contextIndicators
        .sort(sortByOrder)
        .map(indicator => ({
          id: indicator.id,
          name: indicator.name,
          path:
            context.id === 'about'
              ? '/about'
              : `/context/${context.id}/indicator/${indicator.id}`,
          component: IndicatorWrapper,
        }));

      return [...accumulator, ...indicators];
    }, []);

  return routes;
}

export function generateRoutePathById(
  routes: RouteConfigItem[],
): Record<string, string> {
  const routeByPath = routes.reduce(
    (accumulator: Record<string, string>, route) => {
      accumulator[route.id] = route.path;

      return accumulator;
    },
    {},
  );

  return routeByPath;
}

export function generateIndicatorWithContext(
  contexts: EnvironmentWithIndicators[],
): any[] {
  const formattedIndicators = contexts.reduce((accumulator: any[], context) => {
    return [
      ...accumulator,
      ...context.indicators.map(indicator => ({
        ...indicator,
        contextId: context.id,
      })),
    ];
  }, []);

  return formattedIndicators;
}
